import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/swiper-bundle.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initSpecCarousel = () => {
  const carousels = document.querySelectorAll('[data-block="specjaliisci"]');
  carousels.forEach((carousel) => {
    if (carousel._initialized) return;
    carousel._initialized = true;
    const isLayout2 = carousel.classList.contains("layout-2");
    const swiper = new Swiper(carousel, {
      modules: [Navigation],
      slidesPerView: isLayout2 ? 3 : 3,
      centeredSlides: true,
      spaceBetween: 10,
      speed: 700,
      grabCursor: true,
      loop: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: carousel.querySelector(".swiper-specjalisci-button-next"),
        prevEl: carousel.querySelector(".swiper-specjalisci-button-prev"),
      },
    });

    const updateSlideStates = () => {
      const slidesEls = carousel.querySelectorAll(".swiper-slide");
      const realActive = swiper.realIndex;
      const total = slidesEls.length;

      slidesEls.forEach((slide) => {
        slide.classList.remove(
          "is-centered",
          "is-side",
          "left-side",
          "right-side",
        );

        if (slide.classList.contains("swiper-slide-active")) {
          slide.classList.add("is-centered");
        } else {
          slide.classList.add("is-side");

          const leftIndex = (realActive - 1 + total) % total;
          const rightIndex = (realActive + 1) % total;
          const originalIndex = Number(
            slide.getAttribute("data-swiper-slide-index"),
          );

          if (originalIndex === leftIndex) slide.classList.add("left-side");
          if (originalIndex === rightIndex) slide.classList.add("right-side");
        }
      });
    };

    const setSlideStyles = () => {
      const slidesEls = carousel.querySelectorAll(".swiper-slide");

      slidesEls.forEach((slide) => {
        const inner = slide.querySelector(".carousel-card");
        if (!inner) return;

        const progress = slide.progress;
        const absProgress = Math.min(Math.abs(progress), 1);

        gsap.to(slide, {
          scale: 1 - absProgress * 0.1,
          duration: 0.3,
          overwrite: "auto",
          ease: "power1.out",
        });

        !isLayout2 &&
          gsap.to(inner, {
            opacity: 1 - absProgress,
            duration: 0.3,
            overwrite: "auto",
            ease: "power1.out",
          });

        if (slide.classList.contains("is-centered")) {
          slide.style.backgroundColor = "#fff";
          slide.style.backgroundImage =
            "linear-gradient(270deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 40%)";
        } else if (slide.classList.contains("right-side") && !isLayout2) {
          slide.style.backgroundColor = "rgba(0,0,0,0)";
          slide.style.backgroundImage =
            "linear-gradient(90deg, rgba(255,253,247,0.4) 0%, rgba(237,232,225,0.4) 40%)";
        } else if (slide.classList.contains("left-side") && !isLayout2) {
          slide.style.backgroundColor = "rgba(0,0,0,0)";
          slide.style.backgroundImage =
            "linear-gradient(270deg, rgba(255,253,247,0.4) 0%, rgba(237,232,225,0.4) 40%)";
        } else {
          slide.style.backgroundColor = "#fff";
          slide.style.backgroundImage =
            "linear-gradient(270deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 40%)";
        }
      });
    };

    swiper.on("init", () => {
      updateSlideStates();
      setSlideStyles();
    });

    swiper.on("slideChange transitionEnd", () => {
      updateSlideStates();
      setSlideStyles();
    });

    swiper.on("setTranslate", setSlideStyles);

    swiper.init();

    const slides = carousel.querySelectorAll(".swiper-slide");

    gsap.fromTo(
      slides,
      { autoAlpha: 0, y: 50 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.2,
        stagger: 0.12,
        ease: "power2.out",
        scrollTrigger: {
          trigger: carousel,
          start: "top 99%",
          once: true,
        },
      },
    );
  });
};

document.addEventListener("DOMContentLoaded", initSpecCarousel);
window.addEventListener("load", initSpecCarousel);
